import { render, staticRenderFns } from "./agv-tag-ul.vue?vue&type=template&id=8abf09dc&scoped=true&lang=pug&"
import script from "./agv-tag-ul.vue?vue&type=script&lang=js&"
export * from "./agv-tag-ul.vue?vue&type=script&lang=js&"
import style0 from "./agv-tag-ul.vue?vue&type=style&index=0&id=8abf09dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abf09dc",
  null
  
)

export default component.exports